import React , {Component} from "react";
import { TouchableOpacity,View,Text } from "react-native";
import  Colors from "../tools/Colors";
import HMTextView from "./HMTextView";
import {moderateScale} from "../tools/Scaling";

export default class HMButton extends Component {
    render(){
        const {text,textStyle,textType,style,type,borderRadius,height,onPress} = this.props;
        return(
            <TouchableOpacity onPress={onPress} style={[{height:height? height :moderateScale(40),borderRadius:borderRadius?borderRadius:moderateScale(5),alignItems:"center",justifyContent:"center",backgroundColor: type==="outline" ? "transparent": Colors.colorPrimary,paddingHorizontal:10,marginHorizontal:10,borderWidth:type==="outline"?1:0,borderColor:Colors.colorPrimary},style]}>
                    <HMTextView  text={text} type={textType} style={[{color: type==="outline" ? Colors.colorPrimary:Colors.backgroundColor,fontSize:moderateScale(12)},textStyle]}/>
            </TouchableOpacity>
        );
    }
}
